import { ShieldCheck, Award, BadgeCheck, Star, HeartHandshake } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Gas Safe Registered" },
  { icon: Award, label: "11+ Years On The Tools" },
  { icon: BadgeCheck, label: "Fully Insured" },
  { icon: Star, label: "5★ Customer Reviews" },
  { icon: HeartHandshake, label: "12-Month Workmanship Guarantee" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="bg-[#1C2A39] text-[#F9F8F6] c4-grain border-y border-[#E8E5DD]/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-y-4 gap-x-6">
          {items.map((it) => (
            <div
              key={it.label}
              data-testid={`trust-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="flex items-center gap-3"
            >
              <it.icon size={18} strokeWidth={1.5} className="text-[#E9D28B] shrink-0" />
              <span className="text-xs lg:text-sm font-heading tracking-wide">
                {it.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
